module.exports = __webpack_public_path__ + "static/team_7-084bb73376a637d32731209d3fd0d115.jpg";